import { useEffect, useState } from "react";
import Router from "./Routes";
import { getCurrentUser, setCurrentUser } from "./api/amplifyAuth";
import { useAppDispatch } from "./hooks/reduxHooks";
import { setAuthInitialized } from "./store/authStore";
import { BrandIdentifier, CountryKeyManager } from "./utils/environmentManager";
import NavigationTracker from "./components/NavigationTracker";
import { logger } from "./utils/sentryLogger";

function App() {
  const dispatch = useAppDispatch();
  const [brand, setBrand] = useState<BrandIdentifier>(BrandIdentifier.Flexistore);

  useEffect(() => {
    getCurrentUser()
      .then(async (user: any) => {
        setCurrentUser(user, dispatch);

        // Update Sentry logger with user context
        if (user && user.attributes) {
          await logger.updateUserContext();
          logger.info("User authenticated", {
            userId: user.username,
          });
        }
      })
      .catch(console.error)
      .finally(() => dispatch(setAuthInitialized(true)));
  }, [dispatch]);

  useEffect(() => {
    const b = CountryKeyManager.getInstance().getBrand();
    setBrand(b); // trigger re-render with correct brand

    // Set brand as tag in Sentry
    logger.setTag("brand", b === BrandIdentifier.StorPro ? "storpro" : "flexistore");
  }, []);

  return (
    <div className={`App ${brand === BrandIdentifier.StorPro ? "brand-storpro" : "brand-flexistore"}`}>
      <NavigationTracker />
      <Router />
    </div>
  );
}

export default App;
